import { render, staticRenderFns } from "./signatures.vue?vue&type=template&id=4dee0805"
import script from "./signatures.vue?vue&type=script&lang=js"
export * from "./signatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports